import { locationService, productService, stockQuantityLocationService } from 'services/api';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import LocationForm from '../LocationForm';
import { useEffect, useState } from 'react';
import { ILocation, IOption } from 'interfaces';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { StockQuantityLocationColumns } from 'components/common/enhanced/common-headers/stock-quantity-locations';
import SectionTitle from 'components/common/SectionTitle';
import { isTechnicianCoordinator } from 'components/helpers/IsTechnicianCoordinator';
import { isTechnician } from 'components/helpers/IsTechnician';
import { IsSuperAdminGuard } from 'components/helpers/IsSuperAdmin';

export function EditLocation() {
  const translationPrefix = 'pages.locations.edit';
  const { locationId } = useParams();

  const isDisabled = isTechnicianCoordinator() || isTechnician();

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [location, setLocation] = useState<ILocation>();
  const [products, setProducts] = useState<IOption[]>([]);

  useEffect(() => {
    if (locationId) {
      locationService.get(+locationId).then(setLocation);
      productService.getAllBaseInformation().then(setProducts);
    }
  }, []);

  const updateLocation = async (values) => {
    locationService.update(location.id, values).then((res) => {
      if (res.id) {
        setLocation(res);
        enqueueSnackbar(t(`${translationPrefix}.update`), {
          variant: 'success'
        });
      }
    });
  };

  const isAdmin = IsSuperAdminGuard();
  const columnsStockQuantityLocation = StockQuantityLocationColumns(isAdmin);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={location?.code}>
      {/* Card edit FORM*/}
      <Card>
        <CardContent>
          <div className="w-full g-4">
            {location && (
              <LocationForm
                location={location}
                onSubmit={updateLocation}
                disableEdit={isDisabled}
              />
            )}
          </div>
        </CardContent>
      </Card>
      <br />
      <Card>
        <CardContent>
          <div className="w-full g-4">
            {location && (
              <div>
                <div className="m-1">
                  <SectionTitle>{t(`${translationPrefix}.stock-list-menu`)}</SectionTitle>
                </div>
                <br />
                <EnhancedDataGrid
                  service={stockQuantityLocationService}
                  columns={columnsStockQuantityLocation}
                  outerParams={{ location: location.id }}
                  disableDelete
                  disableEdit={isDisabled}
                />
              </div>
            )}
          </div>
          <br />
        </CardContent>
      </Card>
    </TenantPage>
  );
}

export default EditLocation;
